export enum EnumTongHaoStatus {
  Follow = '0',
  Discover = '1',
  InkLightUpLife = '2',
  GoodHomework = '3',
  StudyInsight = '4',
  BackToHoushan = '5',
  SnackTime = '6',
  XuantongGathering = '7',
  ClassmateGathering = '8',
  ClassmateWork = '9',
  FenTong = '10'
}

export enum EnumJoinStatus {
  // 待入群
  Join = '1',
  // 待退出
  Exit = '2'
}

export enum EnumMoreOptions {
  // 更多分桐
  List = '1',
  // 分桐管理
  Manager = '2',
  // 退出分桐
  Exit = '3',
  // 取消退出分桐
  CancelExit = '4'
}

/**
 * 用户关注状态关系
 */
export enum EnumUserFollowRef {
  /**
   * 未关注
   */
  UNFOCUS = 0,
  /**
   * 已关注
   */
  FOCUS = 1,
  /**
   * 被关注
   */
  BEFOCUS = 2,
  /**
   * 互相关注
   */
  MUTUALFOCUS = 3
}

/**
 * 桐学会用户角色
 */
export enum EnumGuildMemberType {
  /**
   * 会员
   */
  Member = 1,
  /**
   * 负责人
   */
  Manager = 2
}

export enum EnumJoinGroupStatus {
  // 未入群
  NotInGroup = 0,
  // 已入群
  InGroup = 1
}

export enum EnumMemberStatus {
  // 入会审核
  JoinAudit = 0,
  // 已入会
  Join = 1,
  // 退会审核
  QuitAudit = 2,
  // 已退会
  Quit = 3
}

// 完善的信息类型
export enum EnumCompleteType {
  /** 手机号 */
  PhoneNum = 'phone',
  /** 微信号 */
  WeChat = 'wechat',
  /** 个人简介 */
  Summary = 'summary',
  /** 个人特长 */
  Specialty = 'specialty'
}
